import React from "react";
import { Input } from "../../../../components/common/Input";

type Props = {
    passwordCurrent: string;
    password: string;
    onChange: (field: "password_current" | "password", value: string) => void;
};

export const PasswordFields: React.FC<Props> = ({ passwordCurrent, password, onChange }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input label="Текущий пароль" name="password_current" value={passwordCurrent} onChange={(v) => onChange("password_current", v)} type="password" autoComplete="current-password" />
        <Input label="Новый пароль" name="password" value={password} onChange={(v) => onChange("password", v)} type="password" autoComplete="new-password" />
    </div>
);
